module.exports = "/work-site/img/working.899a20cc.png";